<div class="video-player-container">
  <video
    #videoPlayer
    class="video-player"
    [ngStyle]="videoStyles()"
    [src]="configuration().src"
    [poster]="configuration().poster"
    [autoplay]="configuration().autoPlay ?? false"
    [controls]="hasBeenPlayed() && (configuration().controls ?? true)"
    [loop]="configuration().loop ?? false"
    [muted]="configuration().muted ?? true"
    preload="metadata"
  >
    {{ 'shared.videoPlayerNotSupported' | translate }}
  </video>

  <!-- Custom Play Button Overlay -->
  @if (showCustomPlayButton()) {
    <div class="custom-play-overlay" (click)="onCustomPlayButtonClick()">
      <button type="button" class="custom-play-button" aria-label="Play video">
        <div class="flex items-center justify-center rounded-full bg-shikenso-purple-base-60 p-5">
          <app-icon src="icons/play-filled-alt.svg" alt="Play video" [size]="32" color="var(--shikenso-base-white)" />
        </div>
      </button>
    </div>
  }
</div>
